import { render, staticRenderFns } from "./CoursesList.vue?vue&type=template&id=2d7cb92f"
import script from "./CoursesList.vue?vue&type=script&lang=js"
export * from "./CoursesList.vue?vue&type=script&lang=js"
import style0 from "./CoursesList.vue?vue&type=style&index=0&id=2d7cb92f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports